// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  MSAL: {
    appId: "be2a0934-cab4-4816-8397-8466ef1f544d",
    fqdn: "globallending.onmicrosoft.com",
    authority: "https://login.microsoftonline.com/globallending.onmicrosoft.com/",
    scopes: ["user.read"],
    redirect: "https://dev-cat.app.glsauto.com"
  }
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts